<div #modalPortal>
  @if (isOpen()) {
  <!-- Backdrop -->
  <button
    type="button"
    class="fixed inset-0 bg-black/25 dark:bg-black/45 backdrop-blur-sm cursor-default"
    style="z-index: 1000"
    aria-label="Close"
    (click)="onCancel()"
  ></button>

  @if (isMobile()) {
  <!-- Mobile: Bottom sheet -->
  <div
    class="fixed bottom-0 left-0 right-0 rounded-t-[28px] bg-white/80 dark:bg-[rgba(15,23,42,0.92)] backdrop-blur-[40px] dark:backdrop-blur-[48px] border-t border-white/30 dark:border-white/10 shadow-[0_-8px_40px_rgba(0,0,0,0.06)] dark:shadow-[0_-8px_40px_rgba(0,0,0,0.5)] p-6 pb-8"
    style="z-index: 1001"
  >
    <!-- Handle -->
    <div class="flex justify-center mb-4 -mt-2">
      <div class="w-10 h-1 rounded-full bg-black/15 dark:bg-white/20"></div>
    </div>

    <!-- Icon + close -->
    <div class="flex items-start justify-between mb-5">
      <div
        class="w-11 h-11 rounded-2xl flex items-center justify-center shrink-0"
        [class]="iconBgClass()"
      >
        <span class="material-symbols-outlined text-[22px]">{{ icon() }}</span>
      </div>
      <button
        type="button"
        class="w-8 h-8 rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-white transition-colors cursor-pointer"
        (click)="onCancel()"
      >
        <span class="material-symbols-outlined text-[20px]">close</span>
      </button>
    </div>

    <h3
      class="text-lg font-bold text-slate-800 dark:text-white mb-2 font-serif"
    >
      {{ title() }}
    </h3>
    <p class="text-sm text-slate-500 dark:text-slate-400 leading-relaxed mb-6">
      {{ message() }}
    </p>

    <div class="flex gap-3">
      <om-button
        variant="ternary"
        size="sm"
        [fullWidth]="true"
        (click)="onCancel()"
      >
        {{ cancelLabel() || ('COMMON.CANCEL' | translate) }}
      </om-button>
      <om-button
        variant="default"
        size="sm"
        [fullWidth]="true"
        (click)="onConfirm()"
      >
        {{ confirmLabel() }}
      </om-button>
    </div>
  </div>
  } @else {
  <!-- Desktop: Centered dialog -->
  <div
    class="fixed inset-0 flex items-center justify-center p-4"
    style="z-index: 1001"
  >
    <div
      class="bg-white/80 dark:bg-[rgba(15,23,42,0.92)] backdrop-blur-[48px] dark:backdrop-blur-[48px] rounded-3xl border border-white/30 dark:border-white/10 shadow-[0_16px_48px_rgba(0,0,0,0.1)] dark:shadow-[0_16px_48px_rgba(0,0,0,0.5)] p-7 min-w-[540px] max-w-lg"
    >
      <!-- Icon + close -->
      <div class="flex items-start justify-between mb-5">
        <div
          class="w-12 h-12 rounded-2xl flex items-center justify-center shrink-0"
          [class]="iconBgClass()"
        >
          <span class="material-symbols-outlined text-[24px]"
            >{{ icon() }}</span
          >
        </div>
        <button
          type="button"
          class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-white hover:bg-slate-100 dark:hover:bg-white/10 transition-colors cursor-pointer"
          (click)="onCancel()"
        >
          <span class="material-symbols-outlined text-[22px]">close</span>
        </button>
      </div>

      <h3
        class="text-xl font-bold text-slate-800 dark:text-white mb-2 font-serif"
      >
        {{ title() }}
      </h3>
      <p
        class="text-sm text-slate-500 dark:text-slate-400 leading-relaxed mb-8"
      >
        {{ message() }}
      </p>

      <div class="flex gap-3">
        <om-button
          variant="ternary"
          size="sm"
          [fullWidth]="true"
          (click)="onCancel()"
        >
          {{ cancelLabel() || ('COMMON.CANCEL' | translate) }}
        </om-button>
        <om-button
          variant="default"
          size="sm"
          [fullWidth]="true"
          (click)="onConfirm()"
        >
          {{ confirmLabel() }}
        </om-button>
      </div>
    </div>
  </div>
  } }
</div>
